module.exports = __webpack_public_path__ + "static/media/518JamesPBrawleyDrNW_2018-06-12_173.3a954365.jpg";